module.exports = __webpack_public_path__ + "static/img/gate.b339541b.svg";